// extracted by mini-css-extract-plugin
export var chevronIcon = "_redotech-redo-return-app-lib-order-version-four-navbar-chevron-icon";
export var navBar = "_redotech-redo-return-app-lib-order-version-four-navbar-nav-bar";
export var navBarLogo = "_redotech-redo-return-app-lib-order-version-four-navbar-nav-bar-logo";
export var userMenuTrigger = "_redotech-redo-return-app-lib-order-version-four-navbar-user-menu-trigger";